export default function () {
  const widgetName = 'flowersWidget';
  const widgetOpts = flowersWidgetOpts;

  // create a function to roate the flower month indicator

  function rotateFlowerIndicator(clickedMonth) {
    // calculate angles based on the number of months
    const angle = 360 / 12;
    // create a function to calculate the position of the flower indicator
    function calculateXY() {
      // calculate the rotation angle based on the clicked month
      // 75 is used to set the flower indicator in the middle of the month
      // becase each month block represents 25% of the width of the calendar wich is 560px
      const rotationAngle = (360 - (clickedMonth - 1) * angle - 75) % 360;
      // radius value is based on the calendar width + 10% and divided by 2
      const radius = window.innerWidth > 992 ? 310 : 175;
      // calculate the x and y coordinates based on the rotation angle and the radius
      const x = radius * Math.cos((rotationAngle * Math.PI) / 180);
      const y = radius * Math.sin((rotationAngle * Math.PI) / 180);
      return { x, y };
    }

    // create a function to calculate the rotation of the flower indicator
    function calculateFinalRotation() {
      // calculate the rotation angle based on the clicked month
      const targetRotation = (clickedMonth - 1) * angle - angle / 2;
      // get the current rotation of the flower indicator
      const currentRotation =
        parseFloat($('#flowerIndicator').css('transform').split(',')[1]) || 0;
      // calculate the difference between the target rotation and the current rotation
      const rotationDiff = targetRotation - currentRotation;
      // calculate the final rotation based on the rotation difference
      // if the rotation difference is greater than 180, subtract 360 from the final rotation
      const finalRotation =
        currentRotation +
        (Math.abs(rotationDiff) > 180 ? -360 : 0) +
        rotationDiff;

      return finalRotation;
    }

    const { x, y } = calculateXY();
    const finalRotation = calculateFinalRotation();

    // move the flower indicator to the center of the calendar
    $('#flowerIndicator').css({
      transform: 'translate(0, 0) rotate(0deg)', // Ir al centro
    });

    // wait 150ms to apply the new coordinates and rotation
    setTimeout(() => {
      // Aplicar las nuevas coordenadas y rotación
      $('#flowerIndicator').css({
        transform: `translate(${-x}px, ${y}px) rotate(${finalRotation}deg)`,
      });
    }, 150);
  }

  // create a function to show the current month when the page is loaded
  function currentlyMonth(flowersInfo) {
    $(`#${widgetName}`).empty();
    // insert the widget before the monthsButton inside the calendar-section
    $(`#${widgetName}`).insertBefore(
      $('.calendar-section .content #monthsButton')
    );

    // get the name of the current month
    // create an array with the names of the months
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    // get the current month
    let currentMonth = new Date().getMonth();
    // get the name of the current month from the array
    const currentMonthName = months[currentMonth];
    // find the current month in flowersInfo by monthName
    const monthValue = flowersInfo.find(
      (month) => month.monthName === currentMonthName
    );
    // if the current month is not in the widget, return
    if (!monthValue) {
      currentMonth = 0;
    }

    // create the template to show the current month information
    const template = `
      <h4>${monthValue.monthName}</h4>
      <ul>
        ${monthValue.flowerList.map((flower) => `<li>${flower}</li>`).join('')}
      </ul>
    `;
    $(`#${widgetName}`)
      .append(template)
      // add the class of the current month to the widget to match the colors of the calendar
      .addClass(`${monthValue.monthName.toLowerCase()}`);
    // rotate the flower indicator to the current month
    rotateFlowerIndicator(currentMonth + 1);
    // set the the flowers image of the current month as the background of the middle circle of the calendar
    $('#flowersPic').css(
      'background-image',
      `url('${FILESERVERIMAGESURL}&i=${monthValue.flowerPic}')`
    );
    // if the current month has a URL, show the monthsButton and set the URL
    if (monthValue.monthURL) {
      $('#monthsButton').attr('href', monthValue.monthURL);
    } else {
      $('#monthsButton').hide();
    }
  }

  // create a function to show the information of the month clicked in the calendar
  function selectMonth(flowersInfo) {
    $('map[name="image_map"] area').on('click', function () {
      // get the name and index of the month clicked
      const monthClicked = $(this).attr('title');
      let monthClickedIndex = $(this).attr('alt');
      // find the month clicked in flowersInfo by monthName
      const monthValue = flowersInfo.find(
        (month) => month.monthName === monthClicked
      );
      // if the month clicked is not in the widget, return
      if (!monthValue) {
        monthClickedIndex = 0;
        return;
      }
      // animate the widget and the flowersPic to fade out
      $(`#${widgetName}`).animate({ opacity: 0 }, 300);
      $('#flowersPic').animate({ opacity: 0 }, 300);
      $('#monthsButton').hide();
      // create the template to show the month clicked information
      const template = `
          <h4>${monthValue.monthName}</h4>
          <ul>
            ${monthValue.flowerList
              .map((flower) => `<li>${flower}</li>`)
              .join('')}
          </ul>
        `;
      // empty the widget and append the template with the month clicked information
      $(`#${widgetName}`).empty();

      // wait 300ms to append the template and change the class of the widget to match the colors of the calendar
      setTimeout(() => {
        $(`#${widgetName}`)
          .append(template)
          .removeClass()
          .addClass(`${monthValue.monthName.toLowerCase()}`);
        // set the the flowers image of the month clicked as the background of the middle circle of the calendar
        $('#flowersPic').css(
          'background-image',
          `url('${FILESERVERIMAGESURL}&i=${monthValue.flowerPic}')`
        );
        // if the month clicked has a URL, show the Load More button and set the URL
        if (monthValue.monthURL) {
          $('#monthsButton').attr('href', monthValue.monthURL);
          $('#monthsButton').show();
        } else {
          $('#monthsButton').hide();
        }
        // check if the append is duplicated
        
        // this line solves the problem of the duplicated append
        if ($(`#${widgetName}`).children().length > 2) {
          $(`#${widgetName}`).children().slice(2).remove();
        }
        // animate the widget and the flowersPic to fade in
        $(`#${widgetName}`).animate({ opacity: 1 }, 200);
        // rotate the flower indicator to the month clicked
        rotateFlowerIndicator(monthClickedIndex);
        $('#flowersPic').animate({ opacity: 1 }, 200);
      }, 300);
    });
  }

  // replicate selectMonth to use rotateFlowerIndicator() but with the hover event
  // $('map[name="image_map"] area').on('mouseenter', function () {
  //   const monthHoveredIndex = $(this).attr('alt');
  //   rotateFlowerIndicator(monthHoveredIndex);
  //   selectMonth(monthHoveredIndex);
  // });

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      // create an array with the information of each month from the widget data
      const flowersInfo = data.items.map((month) => {
        const monthName = month.Title;
        const flowerList = month.Description.split('\r\n');
        const flowerPic = month.Image;
        const monthURL = month.URL;
        return { monthName, flowerList, flowerPic, monthURL };
      });
      // get all the monthNames from the flowersInfo and delete the image_map its area that is not in the flowersInfo
      const monthNames = flowersInfo.map((month) => month.monthName);
      $('map[name="image_map"] area').each(function () {
        if (!monthNames.includes($(this).attr('title'))) {
          $(this).remove();
        }
      });
      currentlyMonth(flowersInfo);
      selectMonth(flowersInfo);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
